import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=47fd2675&scoped=true&"
import script from "./modules.vue?vue&type=script&lang=js&"
export * from "./modules.vue?vue&type=script&lang=js&"
import style0 from "./modules.vue?vue&type=style&index=0&id=47fd2675&lang=scss&scoped=true&"
import style1 from "./modules.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd2675",
  null
  
)

export default component.exports